<div class="modal-header">
    <h1 class="modal-title">Named Login Setup</h1>
</div>
<div class="modal-body">
    <div class="card mb-3" *ngIf="!addUserMode && !changePasswordMode">
        <div class="card-body bg-light border rounded-border">
            <div class="well well-sm">
                Users below are designed to be system admins that are not linked to a PRCo and Employee in Vista.
            </div>
        </div>
    </div>
    <div *ngIf="!addUserMode && !changePasswordMode">
        <label style="font-weight: bold">Login Page</label>
        <input type="text" class="form-control" [(ngModel)]="loginLink" readonly />
    </div>
    <div *ngIf="alert != null" class="alert" [ngClass]="{'alert-success' : alert.type == 'success', 'alert-default' : alert.type == 'default', 'alert-danger': alert.type == 'danger' }" role="alert">
        {{alert.msg}}
        <button type="button" class="close" (click)="closeAlert()">
            <i class="modus-icons">close</i>
        </button>
    </div>
    <br />
    <button type="button" class="btn btn-primary" (click)="toggleAddUserMode(true)" *ngIf="!addUserMode && !changePasswordMode">Add User</button>

    <form #createNamedLoginForm="ngForm" *ngIf="addUserMode">
        <div class="form-group">
            <input type="text" class="form-control"
                   placeholder="Username"
                   [disabled]="performingAction"
                   [(ngModel)]="formData.NamedLogin" required />
        </div>
        <div class="form-group">
            <input type="password" class="form-control"
                   placeholder="Password" autocomplete="off"
                   [(ngModel)]="formData.Password"
                   (change)="clearErrors()"
                   [disabled]="performingAction"
                   (blur)="confirmPassword()" required />
        </div>
        <div class="form-group" [ngClass]="{ 'has-error has-feedback': !passwordsMatch }">
            <input type="password" class="form-control"
                   placeholder="Confirm Password" autocomplete="off"
                   [(ngModel)]="formData.ConfirmPassword"
                   (change)="clearErrors()"
                   [disabled]="performingAction"
                   (blur)="confirmPassword()" required />
            <span [hidden]="passwordsMatch" class="glyphicon glyphicon-remove form-control-feedback"></span>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <p>Passwords must be at least 12 characters long, and must contain at least 3 of the following: lowercase letters, uppercase letters, numbers, and special characters.</p>
                </div>
            </div>
            
        </div>
        <div class="form-group">
            <button type="button" class="btn btn-primary"
                    (click)="addUser()"
                    [disabled]="!passwordsMatch || createNamedLoginForm.invalid || performingAction">
                Add User
            </button>
            <button type="button" class="btn btn-default"
                    (click)="resetForm()"
                    [disabled]="performingAction">
                Cancel
            </button>
        </div>
    </form>
    <form #changePasswordForm="ngForm" *ngIf="changePasswordMode">
        <div class="form-group">
            <input type="text" class="form-control"
                   [placeholder]="formData.NamedLogin"
                   readonly />
        </div>
        <div class="form-group">
            <input type="password" class="form-control"
                   placeholder="New Password" autocomplete="off"
                   [(ngModel)]="formData.Password"
                   (change)="clearErrors()"
                   [disabled]="performingAction"
                   (blur)="confirmPassword()" required />
        </div>
        <div class="form-group" [ngClass]="{ 'has-error has-feedback': !passwordsMatch }">
            <input type="password" class="form-control"
                   placeholder="Confirm Password" autocomplete="off"
                   [(ngModel)]="formData.ConfirmPassword"
                   (change)="clearErrors()"
                   [disabled]="performingAction"
                   (blur)="confirmPassword()" required />
            <span [hidden]="passwordsMatch" class="glyphicon glyphicon-remove form-control-feedback"></span>
        </div>
        <div class="well well-sm">
            <span class="glyphicon glyphicon-info-sign"></span> Passwords must be at least 12 characters long, and must contain at least 3 of the following: lowercase letters, uppercase letters, numbers, and special characters.
        </div>
        <div class="form-group mt-3">
            <button type="button" class="btn btn-primary"
                    (click)="changePassword()"
                    [disabled]="!passwordsMatch || changePasswordForm.invalid || performingAction">
                Change Password
            </button>
            <button type="button" class="btn btn-default"
                    (click)="resetForm()"
                    [disabled]="performingAction">
                Cancel
            </button>
        </div>
    </form>
    <div class="row mt-3" *ngIf="!addUserMode && !changePasswordMode && users.length > 0">
        <div class="col-md-12">
            <table class="table">
                <thead>
                    <tr>
                        <th>
                            Username
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of users">
                        <td>{{user.NamedLogin}}</td>
                        <td>
                            <div class="btn-group">
                                <button type="button" class="btn btn-default rounded-border outline" data-toggle="dropdown">
                                    <span class="oi oi-cog"></span>
                                </button>
                                <ul class="dropdown-menu float-right" role="menu">
                                    <li>
                                        <a class="dropdown-item" style="cursor: pointer;" (click)="removeUser(user)">Remove User</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" style="cursor: pointer;" (click)="changePasswordEnable(user)">Change Password</a>
                                    </li>
                                    <li *ngIf="user.IsUserLockedOut">
                                        <a class="dropdown-item" style="cursor: pointer;" (click)="unlockUser(user)">Unlock User</a>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal()">
        Close
    </button>
</div>
